import { useEffect } from 'react';

let lockCount = 0;
let originalStyles = null;

export default function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked || typeof window === 'undefined') return undefined;

    const html = document.documentElement;
    const body = document.body;

    if (lockCount === 0) {
      originalStyles = {
        htmlOverflow: html.style.overflow,
        bodyOverflow: body.style.overflow,
        htmlOverscroll: html.style.overscrollBehavior,
        bodyOverscroll: body.style.overscrollBehavior,
        bodyPaddingRight: body.style.paddingRight,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyLeft: body.style.left,
        bodyRight: body.style.right,
        bodyWidth: body.style.width,
        scrollX: window.scrollX,
        scrollY: window.scrollY,
      };

      const scrollbarWidth = window.innerWidth - html.clientWidth;
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      html.style.overscrollBehavior = 'none';
      body.style.overscrollBehavior = 'none';
      body.style.position = 'fixed';
      body.style.top = `-${originalStyles.scrollY}px`;
      body.style.left = `-${originalStyles.scrollX}px`;
      body.style.right = '0';
      body.style.width = '100%';

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0 && originalStyles) {
        html.style.overflow = originalStyles.htmlOverflow;
        body.style.overflow = originalStyles.bodyOverflow;
        html.style.overscrollBehavior = originalStyles.htmlOverscroll;
          body.style.overscrollBehavior = originalStyles.bodyOverscroll;
          body.style.paddingRight = originalStyles.bodyPaddingRight;
          body.style.position = originalStyles.bodyPosition;
          body.style.top = originalStyles.bodyTop;
          body.style.left = originalStyles.bodyLeft;
          body.style.right = originalStyles.bodyRight;
          body.style.width = originalStyles.bodyWidth;
          window.scrollTo(originalStyles.scrollX, originalStyles.scrollY);
          originalStyles = null;
        }
    };
  }, [locked]);
}
